<template>
  <span v-if="anyBadge" class="fd-member-badges">
    <sym-icon v-if="membership.au" name="tag-sign" style="color:#59ADC4"></sym-icon>
    <sym-icon v-if="membership.fc" name="tag-comm" style="color:#28CD41"></sym-icon>
    <sym-icon v-if="membership.fb" name="tag-case" style="color:#A2845E"></sym-icon>
    <sym-icon v-if="membership.ft" name="tag-tech" style="color:#608040"></sym-icon>
    <sym-icon v-if="membership.fi" name="tag-money" style="color:#AF52DE"></sym-icon>
  </span>
</template>

<script setup lang="ts">
import SymIcon from "../../helpers/SymIcon.vue";
import {computed} from "vue";
import type {ActiveMembership} from "@t/customer/CustomerMember";

const props = defineProps<{
  membership: ActiveMembership
}>();

const anyBadge = computed(() => props.membership.au || props.membership.fc
    || props.membership.fb || props.membership.ft || props.membership.fi);
</script>

<style>
.fd-member-badges {
  display: inline-flex;
  flex-direction: row;
  align-items: baseline;
  column-gap: 2px;
  flex-flow: wrap;
}
</style>
